module.exports = __webpack_public_path__ + "dist/assets/redesign/ui/components/intro/img/intro-screen-5@3x__c076c07c41198c472e397c201b63d534.png";